export default[
    {
        path: 'rego/finish',
        name: 'thanks-page',
        component: () => import('@/views/thanks-page/Index')
    },
]